import { render, staticRenderFns } from "./alertas-table.vue?vue&type=template&id=16ccd1d9&"
import script from "./alertas-table.vue?vue&type=script&lang=ts&"
export * from "./alertas-table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports